/* ============================================================
   myHarry · Doppelstabmattenzaun – 3D, AR und Live ansehen (29.09.2026)
   Ergaenzt assets/mh-doppelstab-konfigurator.js. Liest die Planung ueber
   root._mhds.model() und baut daraus:
     - 3D: Modell aus Drahtgitter-Matten, Pfosten, Toren und Streifen (three.js)
     - AR: dasselbe Modell als USDZ (iPhone/iPad, Quick Look) bzw. GLB (Android, model-viewer)
     - Live: Zaun als Montage in ein eigenes Gartenfoto (bleibt auf dem Geraet)
   ============================================================ */
(function () {
  'use strict';
  if (window.MHDSExtras) return;
  window.MHDSExtras = true;

  var CSS =
    '.mhds-tools{display:flex;flex-wrap:wrap;gap:8px;margin:12px 0 0}' +
    '.mhds-app .mhds-tools button{font-family:inherit;font-size:12.5px;font-weight:700;line-height:1.2;border-radius:999px;padding:8px 14px;cursor:pointer;border:1.5px solid #D27437;background:#FFF4EA;color:#B5612D;margin:0;min-height:0;height:auto;width:auto;text-transform:none;letter-spacing:normal}' +
    '.mhds-app .mhds-tools button:hover{background:#D27437;color:#fff}' +
    '.mhds-app .mhds-tools button[data-mhdx-live]{border-color:#1565C0;background:#E8F0FB;color:#0D4A96}' +
    '.mhds-app .mhds-tools button[data-mhdx-live]:hover{background:#1565C0;color:#fff}' +
    '.mhdx-ov{position:fixed;inset:0;z-index:2147483000;background:rgba(20,18,16,.72);display:flex;align-items:center;justify-content:center;padding:16px;font-family:var(--font-body-family),"Inter",sans-serif}' +
    '.mhdx-ov *{box-sizing:border-box}' +
    '.mhdx-ov [hidden]{display:none!important}' +
    '.mhdx-box{position:relative;background:#fff;border-radius:16px;width:min(1100px,100%);max-height:calc(100vh - 32px);display:flex;flex-direction:column;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,.35)}' +
    '.mhdx-head{display:flex;align-items:center;gap:10px;padding:12px 16px;border-bottom:1px solid #ece7de}' +
    '.mhdx-head b{font-size:15px;color:#231f20;flex:1}' +
    '.mhdx-ov .mhdx-x{border:0;background:#f3f0ea;border-radius:999px;padding:7px 12px;font-family:inherit;font-size:12.5px;font-weight:700;line-height:1;cursor:pointer;color:#231f20;margin:0;min-height:0;height:auto;width:auto}' +
    '.mhdx-body{position:relative;flex:1;min-height:0;overflow:auto}' +
    '.mhdx-foot{display:flex;flex-wrap:wrap;align-items:center;gap:8px;padding:10px 16px;border-top:1px solid #ece7de;font-size:12.5px;color:#6f685f}' +
    '.mhdx-foot .sp{flex:1}' +
    '.mhdx-ov .mhdx-btn{border-radius:999px;padding:9px 16px;font-family:inherit;font-size:13px;font-weight:700;line-height:1.2;cursor:pointer;border:1.5px solid #D27437;background:#D27437;color:#fff;margin:0;min-height:0;height:auto;width:auto}' +
    '.mhdx-ov .mhdx-btn--ghost{background:#fff;color:#B5612D}' +
    '.mhdx-3d{width:100%;height:min(70vh,640px);display:block;background:#eef1ea;touch-action:none}' +
    '.mhdx-hint{position:absolute;left:12px;top:12px;background:rgba(255,255,255,.9);border:1px solid #ece7de;border-radius:8px;padding:5px 10px;font-size:11.5px;color:#6f685f;pointer-events:none}' +
    '.mhdx-live{display:grid;gap:12px;padding:16px}' +
    '.mhdx-drop{border:2px dashed #d9d2c6;border-radius:14px;padding:34px 18px;text-align:center;color:#6f685f;font-size:14px;display:block;cursor:pointer}' +
    '.mhdx-drop b{display:block;color:#231f20;font-size:16px;margin-bottom:6px}' +
    '.mhdx-stage{position:relative;width:100%;background:#111;border-radius:12px;overflow:hidden;touch-action:none}' +
    '.mhdx-stage canvas{display:block;width:100%;height:auto}' +
    '.mhdx-h{display:block!important;position:absolute;width:22px;height:22px;margin:-11px 0 0 -11px;border-radius:50%;background:#fff;border:3px solid #D27437;box-shadow:0 2px 8px rgba(0,0,0,.4);cursor:grab;touch-action:none}' +
    '.mhdx-h--top{border-color:#1565C0}' +
    '.mhdx-row{font-size:12.5px;color:#6f685f;line-height:1.45}' +
    '.mhdx-h b{position:absolute;left:50%;top:-20px;transform:translateX(-50%);font:700 11px/1 sans-serif;color:#fff;background:#231f20;border-radius:6px;padding:3px 5px;white-space:nowrap;pointer-events:none}' +
    /* Farben je Streifenreihe (Konfigurator, Schritt 4) */
    '.mhds-rc{display:grid;gap:7px}' +
    '.mhds-rc__row{display:flex;align-items:center;gap:10px;flex-wrap:wrap}' +
    '.mhds-rc__n{font-size:12.5px;font-weight:600;min-width:96px;color:#231f20}' +
    '.mhds-rc__dots{display:flex;flex-wrap:wrap;gap:6px}' +
    '.mhds-app .mhds-dot{width:20px;height:20px;border-radius:50%;border:1.5px solid rgba(0,0,0,.18);padding:0;margin:0;min-height:0;cursor:pointer}' +
    '.mhds-app .mhds-dot.on{box-shadow:0 0 0 2px #fff,0 0 0 4px #D27437}';

  function css() {
    if (document.getElementById('mhdxCss')) return;
    var st = document.createElement('style'); st.id = 'mhdxCss'; st.textContent = CSS;
    (document.head || document.documentElement).appendChild(st);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }
  function isIOS() { return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); }
  function isAndroid() { return /Android/i.test(navigator.userAgent); }
  /* 13.10.2026: Sicherheits-Review (S5) – Fremdskripte nur von den festen Quellen (jsDelivr three@0.147.0 und
     model-viewer@3.5.0, Cloudflare Turnstile). Subresource-Integrity-Hashes liegen nicht vor, daher nur Hostpruefung. */
  var SCRIPT_OK = /^https:\/\/(cdn\.jsdelivr\.net\/npm\/(three@0\.147\.0|@google\/model-viewer@3\.5\.0)\/|challenges\.cloudflare\.com\/turnstile\/)/;
  function loadScript(src) {
    return new Promise(function (res, rej) {
      if (!SCRIPT_OK.test(src)) { rej(new Error('script_blocked')); return; }
      var sc = document.createElement('script'); sc.src = src; sc.onload = res; sc.onerror = rej; document.head.appendChild(sc);
    });
  }
  /* 13.10.2026: Sicherheits-Review (S5/S7) – ein Override der Worker-Adresse (window.MH_WPC_LIVE) gilt nur,
     wenn sie per https auf *.workers.dev oder my-harry.de zeigt; sonst bleibt die feste Adresse. */
  function okEndpoint(u) { return typeof u === 'string' && /^https:\/\/[a-z0-9.-]+\.(workers\.dev|my-harry\.de)(\/[^\s]*)?$/i.test(u); }
  /* 13.10.2026: Sicherheits-Review (S7) – Hinweis in der Werkzeugleiste statt alert() */
  function toolMsg(app, text) {
    var bar = app.querySelector('.mhds-tools'); if (!bar) return;
    var m = bar.querySelector('[data-mhdx-msg]');
    if (!m) { m = document.createElement('span'); m.setAttribute('data-mhdx-msg', ''); m.style.cssText = 'flex-basis:100%;font-size:12.5px;color:#b3261e'; bar.appendChild(m); }
    m.textContent = text || '';
  }
  var threeP = null, expP = null;
  function ensureThree() {
    if (window.THREE && window.THREE.OrbitControls) return Promise.resolve(window.THREE);
    if (!threeP) threeP = (window.THREE ? Promise.resolve() : loadScript('https://cdn.jsdelivr.net/npm/three@0.147.0/build/three.min.js'))
      .then(function () { return window.THREE.OrbitControls ? null : loadScript('https://cdn.jsdelivr.net/npm/three@0.147.0/examples/js/controls/OrbitControls.js'); })
      .then(function () { return window.THREE; });
    return threeP;
  }
  function ensureExporters() {
    if (!expP) expP = ensureThree().then(function (T) {
      if (T.GLTFExporter && T.USDZExporter) return T;
      return loadScript('https://cdn.jsdelivr.net/npm/three@0.147.0/examples/js/libs/fflate.min.js')
        .then(function () { return loadScript('https://cdn.jsdelivr.net/npm/three@0.147.0/examples/js/exporters/GLTFExporter.js'); })
        .then(function () { return loadScript('https://cdn.jsdelivr.net/npm/three@0.147.0/examples/js/exporters/USDZExporter.js'); })
        .then(function () { return window.THREE; });
    });
    return expP;
  }
  function overlay(title) {
    css();
    var ov = document.createElement('div');
    ov.className = 'mhdx-ov';
    ov.innerHTML = '<div class="mhdx-box" role="dialog" aria-modal="true" aria-label="' + esc(title) + '">'
      + '<div class="mhdx-head"><b>' + esc(title) + '</b><button type="button" class="mhdx-x">✕ Schließen</button></div>'
      + '<div class="mhdx-body"></div><div class="mhdx-foot"></div></div>';
    document.body.appendChild(ov);
    var closers = [];
    ov.__onClose = function (f) { closers.push(f); };
    ov.__close = function () { closers.forEach(function (f) { try { f(); } catch (e) {} }); ov.remove(); document.removeEventListener('keydown', key, true); };
    function key(e) { if (e.key === 'Escape') { e.stopPropagation(); ov.__close(); } }
    document.addEventListener('keydown', key, true);
    ov.querySelector('.mhdx-x').addEventListener('click', ov.__close);
    ov.addEventListener('click', function (e) { if (e.target === ov) ov.__close(); });
    return ov;
  }

  /* ---------- Geometrie: Seiten im Uhrzeigersinn wie in der Draufsicht ---------- */
  var DIRS = [[1, 0], [0, 1], [-1, 0], [0, -1]];
  function frame(seiten) {
    var pts = [[0, 0]], x = 0, z = 0;
    seiten.forEach(function (L, i) { x += DIRS[i][0] * L; z += DIRS[i][1] * L; pts.push([x, z]); });
    function at(d, preferPrev) {
      var acc = 0;
      for (var i = 0; i < seiten.length; i++) {
        var L = seiten[i];
        var hit = preferPrev ? d <= acc + L + 1e-6 : d < acc + L - 1e-6;
        if (hit || i === seiten.length - 1) { var t = d - acc; return { x: pts[i][0] + DIRS[i][0] * t, z: pts[i][1] + DIRS[i][1] * t, i: i }; }
        acc += L;
      }
      return { x: 0, z: 0, i: 0 };
    }
    return { pts: pts, at: at };
  }

  /* zusammengefasste Quader (ein Mesh je Matte statt hunderter Draehte) */
  var UB = null;
  function Boxes(T) {
    if (!UB) { var g0 = new T.BoxGeometry(1, 1, 1).toNonIndexed(); UB = { p: g0.attributes.position.array, n: g0.attributes.normal.array }; }
    this.p = []; this.n = []; this.T = T;
  }
  Boxes.prototype.add = function (cx, cy, cz, sx, sy, sz) {
    for (var i = 0; i < UB.p.length; i += 3) {
      this.p.push(UB.p[i] * sx + cx, UB.p[i + 1] * sy + cy, UB.p[i + 2] * sz + cz);
      this.n.push(UB.n[i], UB.n[i + 1], UB.n[i + 2]);
    }
  };
  Boxes.prototype.geo = function () {
    var g = new this.T.BufferGeometry();
    g.setAttribute('position', new this.T.Float32BufferAttribute(this.p, 3));
    g.setAttribute('normal', new this.T.Float32BufferAttribute(this.n, 3));
    return g;
  };

  var B0 = 0.04;   /* Bodenfreiheit der Matten */
  /* Drahtgitter einer Matte (lokal: x entlang, y hoch, z quer), Doppelstab 6/5/6, Masche 50 x 200 mm */
  /* 30.09.2026: Drahtstaerken je Mattentyp - 6/5/6 (Standard) oder 8/6/8 (Schwer) */
  function gitter(bx, w, H, R, y0, mt) {
    var dv = mt === '868' ? 0.006 : 0.005, dh = mt === '868' ? 0.008 : 0.006, zo = dv / 2 + dh / 2;
    for (var x = 0.025; x < w - 0.005; x += 0.05) bx.add(x, y0 + H / 2, 0, dv, H, dv);
    /* 30.09.2026: Doppeldraht oben buendig, die 3-cm-Spitzen zeigen nach unten */
    for (var j = 0; j <= R; j++) {
      var y = y0 + H - 0.004 - j * 0.2;
      if (y < y0 - 1e-6) break;
      bx.add(w / 2, y, zo, w, dh, dh);
      bx.add(w / 2, y, -zo, w, dh, dh);
    }
  }

  function buildModel(T, m) {
    var H = m.h / 100, R = m.reihen, F = frame(m.seiten), g = m.g;
    var grp = new T.Group();
    var col = new T.Color(m.farbe.hex).convertSRGBToLinear();
    var mMat = new T.MeshStandardMaterial({ color: col, roughness: 0.55, metalness: 0.35 });
    var mCap = new T.MeshStandardMaterial({ color: new T.Color(0x1d1d1b).convertSRGBToLinear(), roughness: 0.6 });
    var sMats = {};
    function stripMat(hex) { return sMats[hex] || (sMats[hex] = new T.MeshStandardMaterial({ color: new T.Color(hex).convertSRGBToLinear(), roughness: 0.85, side: T.DoubleSide })); }
    function stripHex(r) { return (m.rowCols && m.rowCols[r]) || m.strip; }
    function place(mesh, d, len) {   /* Bauteil ab Laenge d entlang seiner Seite ausrichten (Pfosten: Ende der Seite davor) */
      var p = F.at(d, !len), dir = DIRS[p.i];
      mesh.position.set(p.x, 0, p.z);
      mesh.rotation.y = -Math.atan2(dir[1], dir[0]);
      mesh.castShadow = true;
      grp.add(mesh);
    }
    var cache = {};
    /* 30.09.2026: Hoehe je Feld (mt.h), Pfosten (p.h) und Tor (gt.h) */
    function hOf(o) { return o && o.h ? o.h / 100 : H; }
    function rOf(o) { return o && o.h ? Math.round((o.h - 3) / 20) : R; }
    g.mats.forEach(function (mt) {
      var w = mt.b - mt.a, Hm = hOf(mt), Rm = rOf(mt), key = Math.round(w * 100) + '_' + Math.round(Hm * 100);
      if (!cache[key]) { var bx = new Boxes(T); gitter(bx, w, Hm, Rm, B0, m.mt); cache[key] = bx.geo(); }
      place(new T.Mesh(cache[key], mMat), mt.a, w);
      if (m.strip && m.rows.length) {
        var byHex = {};
        m.rows.forEach(function (r) { if (r >= Rm) return; var hx = stripHex(r); (byHex[hx] = byHex[hx] || new Boxes(T)).add(w / 2, B0 + Hm - 0.104 - r * 0.2, 0, w - 0.02, 0.17, 0.003); });
        Object.keys(byHex).forEach(function (hx) { place(new T.Mesh(byHex[hx].geo(), stripMat(hx)), mt.a, w); });
      }
    });
    var pGeos = {};
    function postGeo(Hp) {
      var k = Math.round(Hp * 100);
      if (!pGeos[k]) {
        var pb = new Boxes(T); pb.add(0, (Hp + 0.07) / 2, 0, 0.04, Hp + 0.07, 0.06);
        var cb = new Boxes(T); cb.add(0, Hp + 0.075, 0, 0.046, 0.012, 0.066);
        pGeos[k] = [pb.geo(), cb.geo()];
      }
      return pGeos[k];
    }
    g.posts.forEach(function (p) {
      var pg = postGeo(hOf(p));
      place(new T.Mesh(pg[0], mMat), p.x, 0);
      place(new T.Mesh(pg[1], mCap), p.x, 0);
    });
    g.gates.forEach(function (gt) {
      var th = gt.h ? (gt.h - 3) / 100 : m.torH / 100, gh = th + 0.12, w = gt.b - gt.a, bx = new Boxes(T);
      [0.03, w - 0.03].forEach(function (x) { bx.add(x, gh / 2, 0, 0.06, gh, 0.06); });
      var flg = gt.t.art === '2' ? 2 : 1, a0 = 0.07, fw = (w - 0.14) / flg;
      for (var k = 0; k < flg; k++) {
        var fx = a0 + k * fw, lw = fw - 0.02, y0 = 0.05, lh = th - 0.04;
        bx.add(fx + lw / 2, y0, 0, lw, 0.04, 0.04); bx.add(fx + lw / 2, y0 + lh, 0, lw, 0.04, 0.04);
        bx.add(fx, y0 + lh / 2, 0, 0.04, lh, 0.04); bx.add(fx + lw, y0 + lh / 2, 0, 0.04, lh, 0.04);
        for (var x = fx + 0.05; x < fx + lw - 0.02; x += 0.05) bx.add(x, y0 + lh / 2, 0, 0.005, lh - 0.04, 0.005);
        for (var y = y0 + 0.2; y < y0 + lh - 0.05; y += 0.2) bx.add(fx + lw / 2, y, 0.0055, lw - 0.04, 0.006, 0.006);
        bx.add(k === 0 ? fx + lw - 0.08 : fx + 0.08, y0 + lh * 0.55, 0.03, 0.02, 0.12, 0.02);   /* Druecker */
        /* 30.09.2026: Sichtschutzstreifen auch im Torfluegel (dieselben Reihen wie in den Matten) */
        if (m.strip && m.rows.length) {
          var byHexT = {}, nc = 1;
          for (var yb2 = y0 + 0.2; yb2 < y0 + lh - 0.05; yb2 += 0.2) nc++;   /* Maschen des Torfluegels (wie die Querdraehte oben) */
          m.rows.forEach(function (r) {
            if (r >= nc) return;
            var top = (r === 0 ? y0 + lh : y0 + 0.2 * (nc - r)) - 0.02, bot = y0 + 0.2 * (nc - r - 1) + 0.02;
            if (top - bot < 0.04) return;
            var hx = stripHex(r); (byHexT[hx] = byHexT[hx] || new Boxes(T)).add(fx + lw / 2, (top + bot) / 2, 0, lw - 0.06, top - bot, 0.003);
          });
          Object.keys(byHexT).forEach(function (hx) { place(new T.Mesh(byHexT[hx].geo(), stripMat(hx)), gt.a, w); });
        }
      }
      place(new T.Mesh(bx.geo(), mMat), gt.a, w);
    });
    /* Mittelpunkt auf den Ursprung */
    var box = new T.Box3().setFromObject(grp), c = box.getCenter(new T.Vector3());
    grp.children.forEach(function (o) { o.position.x -= c.x; o.position.z -= c.z; });
    var sz = box.getSize(new T.Vector3());
    return { group: grp, size: Math.max(sz.x, sz.z, 1), hM: H + 0.1 };
  }

  function model(app) { try { return app._mhds && app._mhds.model ? app._mhds.model() : null; } catch (e) { return null; } }

  /* ---------- 3D ---------- */
  function open3D(app, arHint) {
    var m = model(app); if (!m) return;
    var ov = overlay('Dein Zaun in 3D');
    var body = ov.querySelector('.mhdx-body'), foot = ov.querySelector('.mhdx-foot');
    body.innerHTML = '<div class="mhdx-hint">Ziehen zum Drehen · Scrollen oder zwei Finger zum Zoomen</div>';
    foot.innerHTML = '<span class="sp">' + (arHint ? 'AR funktioniert am Smartphone: öffne diese Seite dort und tippe auf „AR ansehen“ – der Zaun erscheint in Originalgröße in deinem Garten.' : 'Maßstabsgetreu aus deiner Planung.') + '</span>'
      + ((isIOS() || isAndroid()) ? '<button type="button" class="mhdx-btn" data-ar>AR ansehen</button>' : '');
    var arB = foot.querySelector('[data-ar]'); if (arB) arB.addEventListener('click', function () { launchAR(app); });
    var alive = true, raf = 0, renderer = null;
    ov.__onClose(function () { alive = false; cancelAnimationFrame(raf); if (renderer) { renderer.dispose(); if (renderer.forceContextLoss) renderer.forceContextLoss(); } });
    ensureThree().then(function (T) {
      if (!alive) return;
      var M = buildModel(T, m);
      var cv = document.createElement('canvas'); cv.className = 'mhdx-3d'; body.insertBefore(cv, body.firstChild);
      renderer = new T.WebGLRenderer({ canvas: cv, antialias: true });
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      renderer.outputEncoding = T.sRGBEncoding; renderer.shadowMap.enabled = true; renderer.shadowMap.type = T.PCFSoftShadowMap;
      var scene = new T.Scene(); scene.background = new T.Color(0xeef1ea);
      scene.add(new T.HemisphereLight(0xffffff, 0x8a8f7a, 0.9));
      var sun = new T.DirectionalLight(0xffffff, 0.85); sun.position.set(M.size * 0.4 + 3, 7, M.size * 0.5 + 4); sun.castShadow = true;
      sun.shadow.mapSize.set(2048, 2048); var sc = Math.max(M.size, 4);
      sun.shadow.camera.left = -sc; sun.shadow.camera.right = sc; sun.shadow.camera.top = sc; sun.shadow.camera.bottom = -sc;
      scene.add(sun);
      var ground = new T.Mesh(new T.PlaneGeometry(M.size + 10, M.size + 10), new T.MeshStandardMaterial({ color: new T.Color(0x9fb087).convertSRGBToLinear(), roughness: 1 }));
      ground.rotation.x = -Math.PI / 2; ground.receiveShadow = true; scene.add(ground);
      scene.add(M.group);
      var cam = new T.PerspectiveCamera(40, 1, 0.05, 400);
      var dist = Math.max(M.size * 1.2, 4);
      cam.position.set(M.size * 0.15, M.hM + M.size * 0.35 + 0.6, dist);
      var ctl = new T.OrbitControls(cam, cv); ctl.target.set(0, M.hM / 2, 0); ctl.enableDamping = true;
      ctl.maxPolarAngle = Math.PI / 2 - 0.03; ctl.minDistance = 1; ctl.maxDistance = dist * 3; ctl.update();
      function size() { var w = cv.clientWidth, h = cv.clientHeight; if (!w || !h) return; renderer.setSize(w, h, false); cam.aspect = w / h; cam.updateProjectionMatrix(); }
      size(); window.addEventListener('resize', size); ov.__onClose(function () { window.removeEventListener('resize', size); });
      (function loop() { if (!alive) return; ctl.update(); renderer.render(scene, cam); raf = requestAnimationFrame(loop); })();
    }).catch(function () { body.innerHTML = '<p style="padding:20px">Die 3D-Ansicht konnte nicht geladen werden – bitte Seite neu laden.</p>'; });
  }

  /* ---------- AR ---------- */
  var arBusy = false;
  function launchAR(app) {
    var m = model(app); if (!m || arBusy) return;
    arBusy = true;
    ensureExporters().then(function (T) {
      var M = buildModel(T, m);
      M.group.updateMatrixWorld(true);
      if (isIOS()) {
        return new T.USDZExporter().parse(M.group).then(function (data) {
          var url = URL.createObjectURL(new Blob([data], { type: 'model/vnd.usdz+zip' }));
          var a = document.createElement('a'); a.rel = 'ar'; a.href = url; a.style.cssText = 'position:absolute;left:-9999px;top:0';
          a.appendChild(document.createElement('img')); document.body.appendChild(a); a.click();
          setTimeout(function () { a.remove(); }, 4000);
          /* 13.10.2026: Sicherheits-Review (S7) – Blob-URL wieder freigeben (Quick Look hat die Datei dann laengst geladen) */
          setTimeout(function () { try { URL.revokeObjectURL(url); } catch (e) {} }, 30000);
        });
      }
      return new Promise(function (res, rej) { new T.GLTFExporter().parse(M.group, res, rej, { binary: true }); }).then(function (ab) {
        var url = URL.createObjectURL(new Blob([ab], { type: 'model/gltf-binary' }));
        var ov = overlay('AR ansehen');
        var body = ov.querySelector('.mhdx-body');
        body.style.height = '70vh';
        /* 13.10.2026: Sicherheits-Review (S7) – Blob-URL des Modells beim Schliessen wieder freigeben */
        ov.__onClose(function () { try { URL.revokeObjectURL(url); } catch (e) {} });
        function make() {
          var mv = document.createElement('model-viewer');
          mv.setAttribute('src', url); mv.setAttribute('ar', ''); mv.setAttribute('ar-modes', 'webxr scene-viewer quick-look');
          mv.setAttribute('camera-controls', ''); mv.setAttribute('shadow-intensity', '1'); mv.setAttribute('ar-scale', 'fixed');
          mv.setAttribute('alt', '3D-Modell deines Zauns');
          mv.style.cssText = 'width:100%;height:100%;background:#eef1ea';
          body.appendChild(mv);
          mv.addEventListener('load', function () { try { if (mv.canActivateAR) mv.activateAR(); } catch (e) {} });
        }
        if (window.customElements && customElements.get('model-viewer')) make();
        else {
          /* 13.10.2026: Sicherheits-Review (S5) – feste Quelle, Hostpruefung wie bei loadScript */
          var mvSrc = 'https://cdn.jsdelivr.net/npm/@google/model-viewer@3.5.0/dist/model-viewer.min.js';
          if (!SCRIPT_OK.test(mvSrc)) throw new Error('script_blocked');
          var sc = document.createElement('script'); sc.type = 'module'; sc.src = mvSrc; sc.onload = make;
          sc.onerror = function () { body.innerHTML = '<p style="padding:20px">Die AR-Ansicht konnte nicht geladen werden – bitte Seite neu laden.</p>'; };
          document.head.appendChild(sc);
        }
      });
    }).catch(function () { toolMsg(app, 'AR konnte nicht gestartet werden. Bitte Seite neu laden und noch einmal versuchen.'); })   /* 13.10.2026: kein alert() */
      .then(function () { arBusy = false; });
  }

  /* ---------- Live ansehen ---------- */
  /* 30.09.2026: Der Zaun wird direkt als Vektorgrafik perspektivisch ins Foto gezeichnet.
     Vorher: flaches Panorama-Bild, in Streifen verkleinert und verzerrt. Beim Verkleinern
     fielen einzelne 5-cm-Draehte durch das Pixelraster, andere verdoppelten sich - die
     Abstaende wirkten ungleich und verschoben. Jetzt wird jeder Draht, Pfosten und Streifen
     an seiner echten Position berechnet und mit Kantenglaettung gezeichnet.
     P(d, h) liefert fuer Laenge d (m) und Hoehe h (m) den Bildpunkt [x, y, px je m]. */
  function paintSide(c, m, P, d0, d1, skipPost) {
    var g = m.g, H = m.h / 100, col = m.farbe.hex, s868 = m.mt === '868';
    var dv = s868 ? 0.0072 : 0.006, dh = s868 ? 0.008 : 0.006;
    function inSide(a, b) { var mid = (a + b) / 2; return mid >= d0 - 1e-6 && mid <= d1 + 1e-6; }
    function quad(a, b, h0, h1) {
      var p1 = P(a, h0), p2 = P(b, h0), p3 = P(b, h1), p4 = P(a, h1);
      c.beginPath(); c.moveTo(p1[0], p1[1]); c.lineTo(p2[0], p2[1]); c.lineTo(p3[0], p3[1]); c.lineTo(p4[0], p4[1]); c.closePath(); c.fill();
    }
    /* duenne Teile: unter 1 px Breite mit 1 px und entsprechend weniger Deckkraft (gleichmaessig statt flimmernd) */
    function vline(d, h0, h1, wm) {
      var p = P(d, h0), q = P(d, h1), w = wm * p[2], al = Math.min(1, w);
      w = Math.max(1, w); c.globalAlpha = al; c.fillRect(p[0] - w / 2, q[1], w, p[1] - q[1]); c.globalAlpha = 1;
    }
    function hline(a, b, h, wm) {
      var p = P(a, h), q = P(b, h), w = wm * Math.min(p[2], q[2]);
      if (w >= 1) { quad(a, b, h - wm / 2, h + wm / 2); return; }
      c.globalAlpha = w; c.lineWidth = 1; c.beginPath(); c.moveTo(p[0], p[1]); c.lineTo(q[0], q[1]); c.stroke(); c.globalAlpha = 1;
    }
    function gitter(a, w, h, y0, unten) {   /* unten: Spitzen der Matte zeigen nach unten (30.09.2026) */
      c.fillStyle = col; c.strokeStyle = col;
      for (var x = 0.025; x < w - 0.005; x += 0.05) vline(a + x, y0, y0 + h, dv);
      for (var j = 0; j <= 20; j++) {
        var y = y0 + h - (unten ? 0.004 + 0.9 * dh : 0.03) - j * 0.2; if (y < y0 - 1e-6) break;
        hline(a, a + w, y + 0.9 * dh, dh); hline(a, a + w, y - 0.9 * dh, dh);
      }
    }
    function stripCol(r) { return (m.rowCols && m.rowCols[r]) || m.strip; }
    g.mats.forEach(function (mt) {
      if (!inSide(mt.a, mt.b)) return;
      var w = mt.b - mt.a, Hm = mt.h ? mt.h / 100 : H, Rm = mt.h ? Math.round((mt.h - 3) / 20) : m.reihen;
      gitter(mt.a, w, Hm, B0, true);
      if (m.strip && m.rows.length) m.rows.forEach(function (r) {
        if (r >= Rm) return;
        var yc = B0 + Hm - 0.104 - r * 0.2; c.fillStyle = stripCol(r); quad(mt.a + 0.01, mt.b - 0.01, yc - 0.085, yc + 0.085);
      });
    });
    g.gates.forEach(function (gt) {
      if (!inSide(gt.a, gt.b)) return;
      var th = gt.h ? (gt.h - 3) / 100 : m.torH / 100, flg = gt.t.art === '2' ? 2 : 1, w = gt.b - gt.a, fw = (w - 0.14) / flg;
      for (var k = 0; k < flg; k++) {
        var fx = gt.a + 0.07 + k * fw, lwid = fw - 0.02, y0 = 0.05, lh = th - 0.04;
        gitter(fx, lwid, lh, y0);
        if (m.strip && m.rows.length) m.rows.forEach(function (r) {   /* Streifen auch im Tor */
          var top = y0 + lh - 0.03 - r * 0.2, bot = Math.max(y0 + 0.03, top - 0.17);
          if (top - bot < 0.04) return;
          c.fillStyle = stripCol(r); quad(fx + 0.03, fx + lwid - 0.03, bot, top);
        });
        c.fillStyle = col;   /* Rahmen des Fluegels, 40 mm */
        quad(fx - 0.02, fx + lwid + 0.02, y0 - 0.02, y0 + 0.02); quad(fx - 0.02, fx + lwid + 0.02, y0 + lh - 0.02, y0 + lh + 0.02);
        quad(fx - 0.02, fx + 0.02, y0, y0 + lh); quad(fx + lwid - 0.02, fx + lwid + 0.02, y0, y0 + lh);
      }
      c.fillStyle = col;
      [gt.a, gt.b - 0.06].forEach(function (x) { quad(x, x + 0.06, 0, th + 0.12); });
    });
    g.posts.forEach(function (p) {
      if (!(p.x >= d0 - 1e-6 && p.x <= d1 + 1e-6) || (skipPost && skipPost(p.x))) return;
      var l = P(p.x - 0.02, 0), r = P(p.x + 0.02, 0);
      var gr = c.createLinearGradient(l[0], 0, r[0], 0);
      gr.addColorStop(0, col); gr.addColorStop(0.4, '#6b7075'); gr.addColorStop(1, col);
      var Hp = p.h ? p.h / 100 : H;
      c.fillStyle = gr; quad(p.x - 0.02, p.x + 0.02, 0, Hp + 0.07);
      c.fillStyle = '#1d1d1b'; quad(p.x - 0.023, p.x + 0.023, Hp + 0.07, Hp + 0.082);
    });
  }
  function loadImage(url) {
    return new Promise(function (res) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = url; });
  }
  /* ---------- Vorhandenen Zaun entfernen (KI) ----------
     Gemeinsam fuer Sichtschutz- und Doppelstabmattenzaun (steht in beiden Dateien
     gleich, wer zuerst laedt, legt window.MHAltZaun an). Der Kunde setzt die Punkte
     auf den alten Zaun; genau dieser Streifen (etwas hoeher und breiter) geht als
     Maske an den Worker (produkt=entfernen), der Rest des Fotos bleibt unveraendert.
     Der Knopf ist immer da; gesendet wird erst, wenn der Worker unter /caps "entfernen" meldet. */
  if (!window.MHAltZaun) window.MHAltZaun = (function () {
    var EP = 'https://myharry-live.long-smoke-34f8.workers.dev', KEY = '0x4AAAAAAE7k7IJreZbIxOSm', capsP = null, tsP = null;
    /* 13.10.2026: Sicherheits-Review (S5/S7) – Override der Worker-Adresse nur per https auf *.workers.dev oder my-harry.de */
    try { if (window.MH_WPC_LIVE) { if (okEndpoint(window.MH_WPC_LIVE.endpoint)) EP = window.MH_WPC_LIVE.endpoint; KEY = window.MH_WPC_LIVE.siteKey || KEY; } } catch (e) {}
    EP = EP.replace(/\/+$/, '');
    function css() {
      if (document.getElementById('mhazCss')) return;
      var st = document.createElement('style'); st.id = 'mhazCss';
      st.textContent = '.mhaz{border:1px solid #d9e3f2;background:#f4f8fd;border-radius:12px;padding:12px 14px;display:grid;gap:8px;font-size:13px;color:#231f20;line-height:1.45}'
        + '.mhaz b{font-size:14px}.mhaz p{margin:0;color:#4d5663}.mhaz label{display:flex;gap:8px;align-items:flex-start;font-size:12px;color:#6f685f}'
        + '.mhaz label a{color:#B5612D}.mhaz__row{display:flex;flex-wrap:wrap;gap:8px;align-items:center}'
        + '.mhaz button{border-radius:999px;padding:8px 14px;font-family:inherit;font-size:12.5px;font-weight:700;line-height:1.2;cursor:pointer;border:1.5px solid #1565C0;background:#1565C0;color:#fff;margin:0;min-height:0;height:auto;width:auto}'
        + '.mhaz button[disabled]{opacity:.45;cursor:default}.mhaz button.ghost{background:#fff;color:#0D4A96}'
        + '.mhaz__msg{font-size:12.5px}.mhaz__msg.err{color:#b3261e}'
        + '.mhaz__spin{display:inline-block;width:14px;height:14px;border-radius:50%;border:2px solid #cfdcf0;border-top-color:#1565C0;animation:mhazspin 1s linear infinite;vertical-align:-2px;margin-right:6px}'
        + '@keyframes mhazspin{to{transform:rotate(360deg)}}';
      (document.head || document.documentElement).appendChild(st);
    }
    function caps() {
      if (window.MH_ALTZAUN_TEST) return Promise.resolve(true);
      if (!capsP) capsP = fetch(EP + '/caps').then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; })
        .then(function (j) { return !!(j && j.products && j.products.indexOf('entfernen') >= 0); });
      return capsP;
    }
    function turnstile() {
      if (window.turnstile && window.turnstile.render) return Promise.resolve(window.turnstile);
      if (!tsP) tsP = new Promise(function (res, rej) {
        var sc = document.createElement('script'); sc.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        sc.onerror = rej; sc.onload = function () { var n = 0; (function t() { if (window.turnstile && window.turnstile.render) res(window.turnstile); else if (++n < 100) setTimeout(t, 100); else rej(); })(); };
        document.head.appendChild(sc);
      });
      /* 13.10.2026: Sicherheits-Review (S10) – nach einem Fehler darf der naechste Versuch neu laden */
      tsP.catch(function () { tsP = null; });
      return tsP;
    }
    function polyFill(g, polys, sx, sy) {
      polys.forEach(function (p) { g.beginPath(); p.forEach(function (q, i) { if (i) g.lineTo(q[0] * sx, q[1] * sy); else g.moveTo(q[0] * sx, q[1] * sy); }); g.closePath(); g.fill(); });
    }
    function blob(cv, type) { return new Promise(function (res) { cv.toBlob(res, type || 'image/png', 0.92); }); }
    function errText(code) {
      if (code === 'rate_limited') return 'Für den Moment sind die KI-Ansichten aufgebraucht. Bitte später noch einmal versuchen.';
      if (code === 'turnstile_failed') return 'Die Sicherheitsprüfung ist fehlgeschlagen. Bitte noch einmal versuchen.';
      if (code === 'moderation_blocked') return 'Dieses Foto konnte nicht bearbeitet werden. Bitte ein anderes Foto versuchen.';
      if (code === 'photo_too_large') return 'Das Foto ist zu groß. Bitte ein kleineres Bild wählen.';
      return 'Das hat leider nicht geklappt. Bitte noch einmal versuchen.';
    }
    /* Foto und Maske auf hoechstens 1536 px (durch 16 teilbar) bringen, senden, Ergebnis
       auf den Streifen zuschneiden und mit weicher Kante auf das Originalfoto setzen. */
    function run(photo, polys, token, art) {
      var W = photo.width, H = photo.height, k = Math.min(1, 1536 / Math.max(W, H));
      var w = Math.max(256, Math.round(W * k / 16) * 16), h = Math.max(256, Math.round(H * k / 16) * 16);
      var pc = document.createElement('canvas'); pc.width = w; pc.height = h; pc.getContext('2d').drawImage(photo, 0, 0, w, h);
      var mc = document.createElement('canvas'); mc.width = w; mc.height = h;
      var mg = mc.getContext('2d'); mg.fillStyle = '#000'; mg.fillRect(0, 0, w, h);
      mg.globalCompositeOperation = 'destination-out'; mg.fillStyle = '#000'; polyFill(mg, polys, w / W, h / H);
      return Promise.all([blob(pc), blob(mc)]).then(function (b) {
        var fd = new FormData();
        fd.append('turnstile', token); fd.append('photo', b[0], 'photo.png'); fd.append('mask', b[1], 'mask.png');
        fd.append('produkt', 'entfernen'); fd.append('art', art || 'zaun'); fd.append('size', w + 'x' + h);
        return fetch(EP + '/live', { method: 'POST', body: fd });
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (j) { if (!res.ok || !j.image) throw (j && j.error) || 'server_error'; return j; });
      }).then(function (j) {
        /* 13.10.2026: Sicherheits-Review (S1) – nur ein bekanntes Bildformat und reines Base64 als Bild uebernehmen */
        var fmt = /^(png|jpe?g|webp)$/i.test(String(j.format || '')) ? String(j.format).toLowerCase() : 'jpeg';
        if (typeof j.image !== 'string' || !/^[A-Za-z0-9+\/=\s]+$/.test(j.image)) throw 'server_error';
        return new Promise(function (res, rej) {
          var im = new Image();
          im.onload = function () {
            var gen = document.createElement('canvas'); gen.width = W; gen.height = H;
            var gg = gen.getContext('2d'); gg.drawImage(im, 0, 0, W, H);
            var band = document.createElement('canvas'); band.width = W; band.height = H;
            var bg = band.getContext('2d');
            try { bg.filter = 'blur(' + Math.max(2, Math.min(W, H) / 250) + 'px)'; } catch (e) {}
            bg.fillStyle = '#000'; polyFill(bg, polys, 1, 1);
            gg.globalCompositeOperation = 'destination-in'; gg.drawImage(band, 0, 0);
            var out = document.createElement('canvas'); out.width = W; out.height = H;
            var og = out.getContext('2d'); og.drawImage(photo, 0, 0); og.drawImage(gen, 0, 0);
            res(out);
          };
          im.onerror = function () { rej('server_error'); };
          im.src = 'data:image/' + fmt + ';base64,' + j.image;
        });
      });
    }
    /* Bedienfeld: Einwilligung, Sicherheitspruefung, Start. o = { photo(), polys(), onDone(canvas), onClose(), art } */
    function open(host, o) {
      css();
      /* 13.10.2026: Sicherheits-Review (D1) – das Bedienfeld erscheint sofort; die Abfrage beim Worker (/caps)
         und der Bot-Schutz (Turnstile) laufen erst, wenn der Kunde das Einwilligungs-Haekchen gesetzt hat.
         Vorher geht nichts an Fremdhosts. Kann der Worker "entfernen" noch nicht, erklaert das Feld das nur. */
      open2(host, o);
    }
    function open2(host, o) {
      host.innerHTML = '<div class="mhaz"><b>Vorhandenen Zaun entfernen</b>'
        + '<p>Setz die orangen Punkte an den Fuß und die blauen an die Oberkante des <b>alten</b> Zaunes. Genau dieser Streifen wird bereinigt, der Rest des Fotos bleibt unverändert. Danach setzt du die Punkte für den neuen Zaun.</p>'
        /* 13.10.2026: Sicherheits-Review (D2) – einheitlicher Einwilligungstext */
        + '<label><input type="checkbox" data-ok> <span>Ich bin damit einverstanden, dass mein Foto zur Bearbeitung an unseren Server bei Cloudflare und an den Bilddienst OpenAI (USA) übertragen wird. OpenAI speichert die Daten bis zu 30 Tage zur Missbrauchskontrolle und nutzt sie nicht zum Training. Beim ersten Start wird außerdem ein Bot-Schutz von Cloudflare (Turnstile) ausgeführt. Mehr in unserer <a href="/policies/privacy-policy" target="_blank" rel="noopener">Datenschutzerklärung</a>.</span></label>'
        + '<div data-ts></div>'
        + '<div class="mhaz__row"><button type="button" data-go disabled>Jetzt entfernen</button><button type="button" class="ghost" data-x>Abbrechen</button></div>'
        + '<div class="mhaz__msg" data-msg></div></div>';
      var ok = host.querySelector('[data-ok]'), go = host.querySelector('[data-go]'), msg = host.querySelector('[data-msg]');
      var token = '', tsId = null, busy = false, armed = false;
      function upd() { go.disabled = busy || !(ok.checked && token); }
      host.querySelector('[data-x]').addEventListener('click', function () { host.innerHTML = ''; if (o.onClose) o.onClose(); });
      function arm() {
        if (armed) return; armed = true;
        msg.className = 'mhaz__msg'; msg.innerHTML = '<span class="mhaz__spin"></span>Verbindung wird vorbereitet …';
        caps().then(function (can) {
          if (!can) {
            msg.className = 'mhaz__msg'; msg.textContent = 'Diese Funktion wird gerade freigeschaltet und steht in Kürze zur Verfügung. Bis dahin kannst du den neuen Zaun direkt über den alten setzen.';
            go.hidden = true; return;
          }
          return turnstile().then(function (ts) {
            msg.textContent = '';
            tsId = ts.render(host.querySelector('[data-ts]'), { sitekey: KEY, callback: function (t) { token = t; upd(); }, 'expired-callback': function () { token = ''; upd(); }, 'error-callback': function () { token = ''; upd(); } });
          });
        }).catch(function () { armed = false; msg.className = 'mhaz__msg err'; msg.textContent = 'Der Bot-Schutz konnte nicht geladen werden. Bitte Seite neu laden und noch einmal versuchen.'; });
      }
      ok.addEventListener('change', function () { upd(); if (ok.checked) arm(); });
      go.addEventListener('click', function () {
        if (go.disabled) return;
        busy = true; upd();
        msg.className = 'mhaz__msg'; msg.innerHTML = '<span class="mhaz__spin"></span>Der alte Zaun wird entfernt – das dauert etwa eine Minute …';
        var t = token; token = '';
        run(o.photo(), o.polys(), t, o.art).then(function (cv) {
          busy = false; host.innerHTML = '';
          o.onDone(cv);
        }).catch(function (code) {
          busy = false;
          msg.className = 'mhaz__msg err'; msg.textContent = errText(String(code));
          try { if (tsId != null) window.turnstile.reset(tsId); } catch (e) {}
          upd();
        });
      });
    }
    /* Streifen je Abschnitt aus Fusspunkten F und Hoehen Hh: gut 10 % hoeher als markiert,
       seitlich und unten wenig Zugabe (Pfostenkoepfe und -fuesse). Frueher 50 % - dann lagen
       Gartenhaus, Hauswand und Nachbarrasen mit in der Maske und wurden neu erfunden. */
    function polys(F, Hh, W, H) {
      var px = W * 0.012, py = H * 0.01, out = [];
      for (var i = 0; i < F.length - 1; i++) {
        var a = F[i], b = F[i + 1];
        out.push([[a[0] - px, a[1] + py], [b[0] + px, b[1] + py], [b[0] + px, b[1] - Hh[i + 1] * 1.12 - py], [a[0] - px, a[1] - Hh[i] * 1.12 - py]]);
      }
      return out;
    }
    return { caps: caps, open: open, polys: polys };
  })();
  function openLive(app) {
    var m = model(app); if (!m) return;
    var ov = overlay('Live ansehen – dein Zaun in deinem Garten');
    var body = ov.querySelector('.mhdx-body'), foot = ov.querySelector('.mhdx-foot');
    var S = { photo: null, F: null, Hh: null };
    function drop() {
      body.innerHTML = '<div class="mhdx-live"><label class="mhdx-drop"><b>Foto deines Gartens wählen</b>Am besten frontal auf die Stelle, an der der Zaun stehen soll. JPG oder PNG.'
        + '<input type="file" accept="image/jpeg,image/png,image/webp" style="display:block;margin:14px auto 0"></label><div class="mhdx-row" data-msg style="color:#b3261e"></div></div>';
      /* 13.10.2026: Sicherheits-Review (D3) – Hinweis ergaenzt; das Foto geht erst mit Einwilligung an den Worker */
      foot.innerHTML = '<span class="sp">Das Foto bleibt auf deinem Gerät – bis du die KI-Bearbeitung mit Häkchen freigibst.</span>';
      body.querySelector('input').addEventListener('change', function (e) {
        var file = e.target.files && e.target.files[0]; if (!file) return;
        var fr = new FileReader();
        fr.onload = function () {
          loadImage(fr.result).then(function (im) {
            if (!im) { var mm = body.querySelector('[data-msg]'); if (mm) mm.textContent = 'Dieses Bildformat kann dein Browser nicht öffnen (z. B. HEIC). Bitte JPG oder PNG wählen.'; return; }   /* 13.10.2026: kein alert() */
            var k = Math.min(1, 1600 / Math.max(im.width, im.height));
            var cv = document.createElement('canvas'); cv.width = Math.round(im.width * k); cv.height = Math.round(im.height * k);
            cv.getContext('2d').drawImage(im, 0, 0, cv.width, cv.height);
            S.photo = cv; S.orig = null; editor();
          });
        };
        fr.readAsDataURL(file);
      });
    }
    /* Je Seite ein eigenes Viereck: Fusspunkte F[0..n] (Ecken dazwischen) und Hoehen Hh[0..n].
       Jede Seite wird perspektivisch korrekt zwischen ihren beiden Punkten verzerrt. */
    var D = [0]; m.seiten.forEach(function (L, i) { D.push(D[i] + L); });
    function compose(target) {
      var c = target.getContext('2d'), W = target.width, kx = W / S.photo.width, HT = m.h / 100 + 0.16, n = m.seiten.length;
      c.drawImage(S.photo, 0, 0, W, target.height);
      var order = m.seiten.map(function (L, i) { return i; })
        .sort(function (i, j) { return (S.F[i][1] + S.F[i + 1][1]) - (S.F[j][1] + S.F[j + 1][1]); });   /* hinten zuerst */
      order.forEach(function (i) {
        var BL = [S.F[i][0] * kx, S.F[i][1] * kx], BR = [S.F[i + 1][0] * kx, S.F[i + 1][1] * kx], hl = S.Hh[i] * kx, hr = S.Hh[i + 1] * kx;
        var L = Math.max(0.01, m.seiten[i]), d0 = D[i];
        /* perspektivisch korrekt: die niedrigere (fernere) Seite wird gestaucht, die nahe gedehnt */
        function P(d, h) {
          var u = (d - d0) / L, den = (1 - u) * hr + u * hl, t = den > 1e-9 ? u * hl / den : u;
          var k = Math.max(0.01, hl + (hr - hl) * t) / HT;
          return [BL[0] + (BR[0] - BL[0]) * t, BL[1] + (BR[1] - BL[1]) * t - h * k, k];
        }
        /* Eckpfosten nur einmal zeichnen: von der vorderen Seite (die zuletzt gezeichnet wird) */
        var later = function (x) {
          var j = Math.abs(x - D[i]) < 1e-6 ? i - 1 : (Math.abs(x - D[i + 1]) < 1e-6 ? i + 1 : -1);
          return j >= 0 && j < n && order.indexOf(j) > order.indexOf(i);
        };
        paintSide(c, m, P, d0, D[i + 1], later);
      });
    }
    function editor() {
      var n = m.seiten.length;
      body.innerHTML = '<div class="mhdx-live"><div class="mhdx-stage"><canvas></canvas></div>'
        + '<div class="mhdx-row">Orange Punkte: Fußpunkte auf den Boden ziehen · Blaue Punkte: Höhe anpassen.'
        + (n > 1 ? ' Die mittleren Punkte sind die Ecken – zieh sie an die Ecken in deinem Garten, jede Seite wird dann eigenständig perspektivisch eingepasst.' : '') + '</div><div data-rmhost></div></div>';
      foot.innerHTML = '<button type="button" class="mhdx-btn mhdx-btn--ghost" data-new>Anderes Foto</button>'
        + '<button type="button" class="mhdx-btn mhdx-btn--ghost" data-rm hidden>Vorhandenen Zaun entfernen</button>'
        + '<button type="button" class="mhdx-btn mhdx-btn--ghost" data-orig hidden>Originalfoto</button><span class="sp"></span>'
        + '<button type="button" class="mhdx-btn" data-dl>Bild speichern</button>';
      foot.querySelector('[data-new]').addEventListener('click', drop);
      var stage = body.querySelector('.mhdx-stage'), cv = stage.querySelector('canvas');
      cv.width = S.photo.width; cv.height = S.photo.height;
      var W = S.photo.width, Hh = S.photo.height;
      /* Startlage: Draufsicht schraeg gekippt (Seiten zum Betrachter hin weiter unten und groesser) */
      var px = [0], pz = [0];
      m.seiten.forEach(function (L, i) { px.push(px[i] + DIRS[i][0] * L); pz.push(pz[i] + DIRS[i][1] * L); });
      var sx = px.map(function (x, i) { return x + 0.35 * pz[i]; }), sy = pz.map(function (z) { return 0.3 * z; });
      var minX = Math.min.apply(null, sx), maxX = Math.max.apply(null, sx), minY = Math.min.apply(null, sy), maxY = Math.max.apply(null, sy);
      var span = Math.max(maxX - minX, 1), kk = W * 0.8 / span, hBase = m.h / 100 * kk;
      if (hBase > Hh * 0.35) { kk *= Hh * 0.35 / hBase; hBase = Hh * 0.35; }
      if (hBase < Hh * 0.06) hBase = Hh * 0.06;
      var yBot = Hh * 0.88 - (maxY - minY) * kk, x0 = (W - span * kk) / 2;
      S.F = sx.map(function (x, i) { return [x0 + (x - minX) * kk, Math.min(Hh * 0.95, yBot + (sy[i] - minY) * kk)]; });
      S.Hh = pz.map(function (z) { return hBase * (1 + 0.25 * (z - Math.min.apply(null, pz)) / Math.max(1, span)); });
      var handles = [];
      function handle(i, top) {
        var d = document.createElement('div'); d.className = 'mhdx-h' + (top ? ' mhdx-h--top' : '');
        stage.appendChild(d); handles.push({ el: d, i: i, top: top });
        d.addEventListener('pointerdown', function (ev) {
          ev.preventDefault(); try { d.setPointerCapture(ev.pointerId); } catch (x) {}
          function mv(e) {
            var rc = cv.getBoundingClientRect(), k2 = S.photo.width / rc.width;
            var x = Math.max(0, Math.min(S.photo.width, (e.clientX - rc.left) * k2)), y = Math.max(0, Math.min(S.photo.height, (e.clientY - rc.top) * k2));
            if (top) S.Hh[i] = Math.max(10, S.F[i][1] - y); else S.F[i] = [x, y];
            draw();
          }
          function up() { d.removeEventListener('pointermove', mv); d.removeEventListener('pointerup', up); d.removeEventListener('pointercancel', up); }
          d.addEventListener('pointermove', mv); d.addEventListener('pointerup', up); d.addEventListener('pointercancel', up);
        });
      }
      for (var i = 0; i <= n; i++) { handle(i, false); handle(i, true); }
      function place() {
        var rc = cv.getBoundingClientRect(), k = rc.width / S.photo.width;
        handles.forEach(function (h) {
          var p = S.F[h.i];
          h.el.style.left = (p[0] * k) + 'px'; h.el.style.top = ((h.top ? p[1] - S.Hh[h.i] : p[1]) * k) + 'px';
        });
      }
      var pend = 0;
      function draw() { if (pend) return; pend = requestAnimationFrame(function () { pend = 0; compose(cv); place(); }); }
      draw();
      /* Vorhandenen Zaun entfernen: nur sichtbar, wenn der Worker es kann */
      var rmB = foot.querySelector('[data-rm]'), orB = foot.querySelector('[data-orig]'), rmHost = body.querySelector('[data-rmhost]');
      if (S.orig) orB.hidden = false;
      rmB.hidden = false;   /* immer sichtbar; ob die KI schon bereitsteht, klaert das Bedienfeld */
      rmB.addEventListener('click', function () {
        window.MHAltZaun.open(rmHost, {
          art: 'doppelstabzaun',
          photo: function () { return S.photo; },
          polys: function () { return window.MHAltZaun.polys(S.F, S.Hh, S.photo.width, S.photo.height); },
          onDone: function (c) { if (!S.orig) S.orig = S.photo; S.photo = c; orB.hidden = false; draw(); }
        });
        rmHost.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
      orB.addEventListener('click', function () { if (S.orig) { S.photo = S.orig; S.orig = null; orB.hidden = true; draw(); } });
      window.addEventListener('resize', draw); ov.__onClose(function () { window.removeEventListener('resize', draw); });
      foot.querySelector('[data-dl]').addEventListener('click', function () {
        var out = document.createElement('canvas'); out.width = S.photo.width; out.height = S.photo.height; compose(out);
        out.toBlob(function (b) {
          var a = document.createElement('a'), u = URL.createObjectURL(b); a.href = u; a.download = 'myharry-doppelstabzaun-live.jpg'; document.body.appendChild(a); a.click();
          /* 13.10.2026: Sicherheits-Review (S7) – Blob-URL nach dem Download wieder freigeben */
          setTimeout(function () { a.remove(); try { URL.revokeObjectURL(u); } catch (e) {} }, 10000);
        }, 'image/jpeg', 0.92);
      });
    }
    drop();
  }

  /* ---------- Werkzeugleiste unter der Ueberschrift ---------- */
  function init(app) {
    if (!app._mhds || app.querySelector('.mhds-tools')) return;
    var head = app.querySelector('.mhds-head'); if (!head) return;
    css();
    var bar = document.createElement('div');
    bar.className = 'mhds-tools';
    bar.innerHTML = '<button type="button" data-mhdx-3d>3D ansehen</button><button type="button" data-mhdx-ar>AR ansehen</button><button type="button" data-mhdx-live>Live ansehen</button>';
    head.appendChild(bar);
    bar.querySelector('[data-mhdx-3d]').addEventListener('click', function () { open3D(app, false); });
    bar.querySelector('[data-mhdx-ar]').addEventListener('click', function () { if (isIOS() || isAndroid()) launchAR(app); else open3D(app, true); });
    bar.querySelector('[data-mhdx-live]').addEventListener('click', function () { openLive(app); });
  }
  function scan() { [].forEach.call(document.querySelectorAll('.mhds-app'), init); }
  window.MHDSExtrasScan = scan;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  setTimeout(scan, 600); setTimeout(scan, 2500);
})();